

















import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
import { ApexOptions } from 'apexcharts';

export default Vue.extend({
  components: {
    apexchart: VueApexCharts,
  },
  props: ['propertyName'],
  computed: {
    chartOptions(): ApexOptions {
      const labelProps = Object.keys(this.$store.getters.labelAnalysisResult);

      return {
        chart: {
          type: 'bar',
          stacked: true,
          stackType: '100%',
          toolbar: {
            show: false,
          },
          width: '100%',
        },
        colors: ['#5BD99C', '#FF974D', '#FC5E54'],
        xaxis: {
          categories: labelProps,
          labels: {
            show: false,
          },
        },
        yaxis: {
          title: {
            text: undefined,
          },
        },
        stroke: {
          width: 1,
          colors: ['#fff'],
        },
        fill: {
          opacity: 1,
        },
        legend: {
          horizontalAlign: 'right',
          position: 'top',
          fontSize: '12px',
          show: true,
        },
        dataLabels: {
          formatter: function (val) {
            let rtData = String(Math.round((val as number) * 100) / 100) + '%';

            if (val !== 100 && rtData === '100%') {
              rtData = '99.99%';
            }

            return val !== 0 ? rtData : '';
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '100%',
          },
        },
      };
    },
    barSeries(): { name: string; data: Array<number> }[] {
      const barSeries = [
        {
          name: '정상',
          data: [] as Array<number>,
        },
        {
          name: '결측치',
          data: [] as Array<number>,
        },
        {
          name: '구문오류',
          data: [] as Array<number>,
        },
      ];

      const labelAnalysis = this.$store.getters.labelAnalysisResult;
      const schemaAnalysis =
        this.$store.getters.schemaAnalysisResult.violationPerProp;

      if (!schemaAnalysis) return barSeries;

      for (const prop in labelAnalysis) {
        let normalCount = labelAnalysis[prop].count;
        let missingValue = labelAnalysis[prop].missing_value;
        let syntaxError = 0;

        const schemaKey = '/' + prop.replaceAll('.', '/');
        const parentSchemaKeyArray = schemaKey.split('/');
        const myPropName = parentSchemaKeyArray.pop();
        const parentSchemaKey = parentSchemaKeyArray.join('/');
        if (schemaAnalysis[parentSchemaKey]) {
          const violationList = schemaAnalysis[parentSchemaKey].violation_list;
          let requiredViolationCnt = 0;
          for (let i = 0; i < violationList.length; i++) {
            if (
              violationList[i].keyword === 'required' &&
              violationList[i].message.includes(`'${myPropName}'`)
            ) {
              requiredViolationCnt++;
            }
          }

          syntaxError += requiredViolationCnt;
          missingValue -= requiredViolationCnt;
        }

        if (schemaAnalysis[schemaKey]) {
          syntaxError += schemaAnalysis[schemaKey].count;

          const violationList = schemaAnalysis[schemaKey].violation_list;
          let nullViolationCnt = 0;
          for (let i = 0; i < violationList.length; i++) {
            nullViolationCnt += violationList[i].given_data === null ? 1 : 0;
          }
          missingValue -= nullViolationCnt;
        }

        normalCount = normalCount - syntaxError;

        barSeries[0].data.push(normalCount);
        barSeries[1].data.push(missingValue);
        barSeries[2].data.push(syntaxError);
      }

      return barSeries;
    },
  },
});
